<template>
  <div class="half-grad" :style="{height: `${fullHeight}px`}">
    <div class="titles-row">
      <h3>Substance A</h3>
      <h3>Substance B</h3>
    </div>
    <div class="compare">

      <div class="therm-contain .therm1">
        <div class="therm-box">
          <img src="../assets/therm.svg">
          <div class="bar-contain">
            <div class="bar" :style="{height: `${thermA}%`}"></div>
          </div>
        </div>
      </div>


      <div class="substance-contain substance-a">
        <div class="dots-container">
          <div class="dots-circle">
            <Dots fill="orange" :wiggle="wiggleA" :w="230" :h="230" />
          </div>
        </div>
      </div>


      <div class="amt-box">
        <div class="box">
          <p class="title">Equal Amounts</p>
          <div class="line">
            <span class="left">Mass</span>
            <span class="right">100. g</span>
          </div>
          <div class="line">
            <span class="left">Energy</span>
            <span class="right">1000. J</span>
          </div>

          <div class="btn-contain" 
          :style="{justifyContent: heated ? 'space-between' : 'center'}">
            <button class="heat-btn btn orange" @click="heatUp" v-if="!heated"><span class="text">Heat Up</span> <img class="lil-flame" src="../assets/flame-solid.svg" alt=""></button>
            <button class="btn hollow" @click="unHeat"  v-if="heated">Reset</button>
            <router-link to="/review/what-changed" class="btn" @click="heatUp" v-if="heated">Continue</router-link>
          </div>
        </div>
      </div>


      <div class="substance-contain substance-b">
        <div class="dots-container">
          <div class="dots-circle">
            <Dots fill="yellow" :wiggle="wiggleB" :w="230" :h="230" />
          </div>
        </div>
      </div>


      <div class="therm-contain therm2">
        <div class="therm-box">
          <img src="../assets/therm-dark.svg">
          <div class="bar-contain">
            <div class="bar" :style="{height: `${thermB}%`}"></div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>


<script>
import Dots from '../components/Dots'
import { mapGetters } from 'vuex'
export default {
  name:"Compare",
  components:{
    Dots
  },
  data() {
    return {
      wiggleA: 0.7,
      wiggleB: 0.7,
      heated: false,
      thermA: 10,
      thermB: 10
    }
  },
  methods: {
    heatUp(){
      this.wiggleA = 1.5
      this.wiggleB = 1.2
      this.heated = true
      this.thermA = 70
      this.thermB = 50
    },
    unHeat(){
      this.wiggleA = 0.7
      this.wiggleB = 0.7
      this.heated = false
      this.thermA = 10
      this.thermB = 10
    }
  },
  computed: mapGetters(['fullHeight'])
}
</script>


<style lang="scss">
  .titles-row{
    display: flex;
    padding-top: 3rem;
    flex: 0 0 auto;

    h3{
      flex: 1 1 50%;
      display: block;
    }
  }

  .therm-box{
    position: relative;

    img{
      position: relative;
      z-index: 3;
    }

    .bar-contain{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding-bottom: 30%;

      .bar{
        width: 20%;
        background: $red;
        border-radius: 10px 10px 0 0;
        transition: height 500ms;
      }
    }
  }
  
  
  .compare{
    display: flex;
    // height: calc( 100vh - 6.7rem);
    flex: 1 1 auto;
    // min-height: -webkit-fill-available;

    .therm-contain{
      flex: 1 1 6.25rem;
      display: flex;
      justify-content: center;
      align-items: flex-end;

      .therm-box{
        margin-bottom: 3rem;
      }
    }

    .substance-contain{
      flex: 1 1 22rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      h3{
        flex: 0 0 auto;
        padding: 3rem;
      }

      .dots-container{
        flex: 1 1 auto;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .dots-circle{
          border-radius: 100%;
          overflow: hidden;
          height: 14rem;
          width: 14rem;

          svg { margin-left: -1rem; margin-top: -1rem; width: 16rem; max-width: none; }

        }

      }
    }

    .amt-box{
      flex: 1 1 18rem;
      display: flex;
      align-items: center;
      justify-content: center;
      

      .box{
        box-shadow: 2px 2px 5px rgba($dark, 0.5);
        background: #ffffff;
        width: 100%;
        border: solid 1px $dark;

        p{
          padding: 0.5rem;
          margin: 0;
          border-bottom: solid 1px $dark;
        }

        .title{
          padding: 0.5rem;
          background: $light;
          margin: 0;
          text-transform: uppercase;
          font-weight: bold;
          font-size: 1.2rem;
          color: $grey;
        }

        .line{
          display: flex;
          border-bottom: solid 1px $dark;
          font-size: 1.1rem;

          .left{
            flex: 1 1 50%;
            padding: 1rem;
          }
          .right{
            flex: 1 1 50%;
            padding: 1rem;
          }
        }

        .btn-contain{
          padding: .5rem;
          background: $light;
          display: flex;
          justify-content: space-between;

          .hollow.btn{
            border-color: transparent;
          }
        }
      }
    }
  }


</style>